export default "__VITE_ASSET__ByzlXmVW__"